import { postCreator } from '../../../http';
import environment from '../../../environment';

const endpoints = Object.freeze({
  PUT_EMAIL: `${environment.apiUrl}/auth/email`,
  POST_PHONE: `${environment.apiUrl}/auth/phone`,
  POST_PHONE_VERIFY: `${environment.apiUrl}/auth/phone/verify`,
});

export const putEmailApi = postCreator(fetch, endpoints.PUT_EMAIL);
export const postPhoneApi = postCreator(fetch, endpoints.POST_PHONE);
export const postPhoneVerifyApi = postCreator(fetch, endpoints.POST_PHONE_VERIFY);



// WEBPACK FOOTER //
// ./src/modules/preferences/security/api.js